import { FatClassFiscal } from './../interfaces/fat-class-fiscal';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class FatClassFiscalService {


  readonly path = '/classfiscal';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  // create(): Observable<FatClassFiscal> {
  //   return this.http.post<FatClassFiscal>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  // }


  getClassFiscal(id: String): Observable<FatClassFiscal> {
    return this.http.get<FatClassFiscal>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getClassFiscalPage(page?: number, size?: number): Observable<PageResult<FatClassFiscal>> {
    return this.http.get<PageResult<FatClassFiscal>>(
      `${this.jwtAuthService.apiUrl + this.path}/page/get?page=${page}&size=${size}`);
  }

  getClassFiscalPageSearch( search?: string, page?: number, size?: number): Observable<PageResult<FatClassFiscal>> {
    return this.http.get<PageResult<FatClassFiscal>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?search=${search}&page=${page}&size=${size}`);
  }

  getClassFiscalList(): Observable<FatClassFiscal[]> {
    return this.http.get<FatClassFiscal[]>(
      `${this.jwtAuthService.apiUrl + this.path}/lista/get`);
  }

  

  saveOrUpdate(grupo: FatClassFiscal): Observable<FatClassFiscal> {
    return this.http.put<FatClassFiscal>(`${this.jwtAuthService.apiUrl + this.path}`, grupo);
  }

  // delete(id: number): Observable<any> {
  //   return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  // }

}
